import React from "react";

import Header from "./Header";
import Footer from "./Footer";

import "../styles/components/layout.sass";

function Layout({ children }) {
  return (
    <div className="content-wrapper">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
